
import CardSlider from '~/components/CardSlider.vue'
import PreHead from '~/components/ui/PreHead.vue'
export default {
  props: {
    gallery: {
      type: Array,
      required: false,
      default: null
    }
  },
  computed: {
    slides() {
      let collectedSlides = []
      if (this.gallery !== undefined && this.gallery.length > 0) {
        this.gallery[0].images.forEach((image) => {
          if (image.image != '' && image.image != undefined) {
            collectedSlides.push({ image: image.image })
          }
        })
      }
      return collectedSlides
    }
  },
  components: {
    CardSlider,
    PreHead
  }
}
